export const ACTIVITY_OPTIONS = [
  { id: 1, name: 'Agendamento' },
  { id: 2, name: 'Retorno' },
  { id: 3, name: 'Contato' },
];
